import classnames from 'classnames';

import {A} from 'components/atoms/LinksAndButtons/A';
import { LinkStyle, ParagraphSize } from 'features/ui/enums';
import {Container} from 'components/atoms/Layout/Container';
import {Icon} from 'components/atoms/Media/Icon';
import {P} from 'components/atoms/Text/P';
import {ScrollToTop} from 'components/atoms/ScrollToTop';
import { useDeviceStore, selectIsMobile, selectIsTablet } from 'features/ui/store/useDeviceStore';
import React from 'react';
import {FormattedMessage} from 'react-intl';

import {isEnglishSite} from 'features/services/utils/env-helper';
import {getPlaceName} from 'features/services/utils/name-helpers';
import {Breadcrumb} from 'features/template/types';

import './style.scss';
import { getFormattedMessage } from 'features/services/utils/language-helper';

interface Props {
    breadcrumbs: Breadcrumb[];

    scrollTop?: boolean;
    old?: boolean;
    noScroll?: boolean;

    narrow?: boolean;
    large?: boolean;
    largeMargin?: boolean;
    center?: boolean;
    noPaddingTop?: boolean;
    noPaddingSides?: boolean;
    residence?: boolean;
    reference?: boolean;
}

export const Breadcrumbs: React.FunctionComponent<Props> = ({
    breadcrumbs,
    scrollTop, old, noScroll,
    narrow, large, largeMargin, center, noPaddingTop, noPaddingSides, residence, reference
}) => {

    const isMobile = useDeviceStore(selectIsMobile);
    const isTablet = useDeviceStore(selectIsTablet);


    const classes = classnames('breadcrumbs', {
        'breadcrumbs--no-top-padding': noPaddingTop,
        'breadcrumbs--no-side-padding': noPaddingSides,
        'breadcrumbs--large-margin': largeMargin,
        'breadcrumbs--old': old,
        'breadcrumbs--residence': residence,
    });
    const wrapperClasses = classnames('breadcrumbs-wrapper', {
        'breadcrumbs--no-scroll': noScroll || residence,
    });
    const divider = old ? <span>/</span> : <Icon name="chevron-thin" size={16} />;

    return (
        <Container className={wrapperClasses} narrow={narrow}>
            {scrollTop && <ScrollToTop />}
            <div className={classes}>
                {residence ?
                    <P size={reference ? ParagraphSize.L : undefined}>
                        {breadcrumbs && breadcrumbs.filter(b => b.url !== '/').map((breadcrumb: Breadcrumb, index) => {

                            // Whats this for?
                            //(index + 1 == breadcrumbs.length && !reference) return;


                            //if (breadcrumb.url && breadcrumb.url !== "" && index + 1 < breadcrumbs.length) {
                                return (
                                    <span key={`breadcrumb-${index}`}>
                                        {index > 0 && <span> / </span>}
                                        {breadcrumb.url ?
                                            <A
                                                href={breadcrumb.url}
                                                variant={LinkStyle.TEXT_COLOR}
                                                route
                                                className="notranslate"
                                                title={getPlaceName(breadcrumb.name, breadcrumb.displayName, breadcrumb.type)} 
                                            >
                                                {getPlaceName(breadcrumb.name, breadcrumb.displayName, breadcrumb.type)}
                                            </A> :
                                            <span className="notranslate">
                                                {getPlaceName(breadcrumb.name, breadcrumb.displayName, breadcrumb.type)}
                                            </span>
                                        }
                                    </span>
                                );
                                /*
                            } else {
                                return (
                                    <UserAgent tablet computer key={`breadcrumbs-${index}`}>
                                        <span className="notranslate" key={`breadcrumb-${index}`}>
                                            {index > 0 && <span> / </span>}
                                            {breadcrumb.title}
                                        </span>
                                    </UserAgent>
                                );
                            }

                                 */
                        })}
                    </P> :
                    <P size={large ? ParagraphSize.L : ParagraphSize.S} center={center}>
                        {((!isMobile || (breadcrumbs && breadcrumbs.length > 0 && breadcrumbs[0].url === '/' && breadcrumbs.length === 2))) &&
                            <span className='breadcrumb'>
                                <A
                                    href={isEnglishSite() ? "/en/about-us/" : "/"}
                                    route
                                    className="notranslate"
                                    variant={LinkStyle.UNSTYLED}
                                    title={getFormattedMessage('jm.components.BreadCrumb.goHome')}
                                >
                                    <FormattedMessage id="jm.components.BreadCrumb.goHome"/>
                                </A>
                                {(!isMobile || (isTablet && breadcrumbs.length === 2)) && divider}
                            </span>
                        }
                        {breadcrumbs && breadcrumbs.map((breadcrumb: Breadcrumb, index) => {
                            if (index + 1 < breadcrumbs.length) {
                                if(breadcrumb.url === '/') return;
                                return <span
                                    key={`breadcrumb-${index}`}
                                    className='breadcrumb'
                                >
                                    {(breadcrumb.url && breadcrumb.url !== "") ?
                                        <A
                                            href={breadcrumb.url}
                                            route
                                            className="notranslate"
                                            variant={!old ? LinkStyle.UNSTYLED : LinkStyle.TEXT_COLOR}
                                            title={breadcrumb.name}
                                        >
                                            {breadcrumb.name}
                                        </A> :
                                        <span>{breadcrumb.name}</span>
                                    }
                                    {(
                                        ((index + 2 < breadcrumbs.length) && (isMobile && !isTablet)) ||
                                        ((index + 1 < breadcrumbs.length) && (!isMobile || isTablet))) &&
                                        divider
                                    }

                                </span>
                            } else if((!isMobile || isTablet)) {
                                return <span
                                    key={`breadcrumb-${index}`}
                                    className='breadcrumb'
                                >
                                    {breadcrumb.name}
                                </span>
                            } else return;
                        })}
                    </P>
                }
            </div>
        </Container>
    )
};

